var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('carousel-comp',{staticClass:"mx-auto",staticStyle:{"width":"90%"}}),_c('list-brands'),_c('latest-hp'),_c('top-by-interest')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }